import { render, staticRenderFns } from "./EcommerceDashboard.vue?vue&type=template&id=7a658180&"
import script from "./EcommerceDashboard.vue?vue&type=script&lang=js&"
export * from "./EcommerceDashboard.vue?vue&type=script&lang=js&"
import style0 from "./EcommerceDashboard.vue?vue&type=style&index=0&id=7a658180&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports